import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {PartSearchResult} from '../products/part-search-result';
import {GoogleService} from './google-service';
import {map} from 'rxjs/operators';
import {BrandID} from "../enums/brand-id";
import {SelectionItem} from "../selections/selection-item";

@Service()
export class PartsService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getPartsFilterData(searchterm: string, brandID: BrandID): Observable<SelectionItem[]> {
    let url = this.urlBase + 'parts/partsfilterdata/' + searchterm + '/' + brandID;
    return this.http.get<SelectionItem[]>(url, {headers: this.getRequestHeaders()});
  }

  public searchParts(searchTerm: string, warranty: boolean, entityId: string, entityRevision: number,
     brandID: BrandID, projectProductType: string, effectiveDate: string): Observable<PartSearchResult> {
    let url = this.urlBase + 'parts/' + searchTerm + '/' + warranty;
    const params: { [key: string]: string } = {};
    if (entityId?.length > 0) {
      params['entityId'] = entityId;
      params['revision'] = entityRevision.toString();
    }
    if (effectiveDate?.length > 0) {
      params['effectiveDate'] = effectiveDate;
    }
    if(brandID?.length > 0) {
      params['brandID'] = brandID;
    }
    if(projectProductType?.length > 0) {
      params['projectProductType'] = projectProductType;
    }
    return this.http.get<PartSearchResult>(url, { headers: this.getRequestHeaders(), params: params });
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  isDrawingAvailable(partNumber: string): Observable<string> {
    const url = this.urlBase + 'parts/drawingFile/isAvailable/' + encodeURIComponent(partNumber);
    return this.http.get(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  getDrawingFile(partNumber: string): Observable<Blob> {
    const url = this.urlBase + 'parts/drawingFile/download/' + encodeURIComponent(partNumber);
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => {
      return new Blob([response.body], {type: response.headers.get('Content-Type')});
    }));
  }

}
